import { useLocation, useNavigate } from 'react-router-dom'
import { ArrayFieldValue, GroupedFieldValues } from '../../types'
import { useCallback, useRef, useState } from 'react'
import { YesObject } from '@yes.technology/react-toolkit'

type SitemodelHistory = {
  url: string
  targetField?: string
  targetGroup?: string
  filterState: GroupedFieldValues
  targetComponent?: string
  selectedOptions?: ArrayFieldValue
}

type LocationStateType = {
  sitemodelHistory?: SitemodelHistory[]
  persistentSelection?: GroupedFieldValues | YesObject[]
  shouldPersistData?: boolean
  shouldResetData?: boolean
  targetComponent?: string
  targetField?: string
  targetGroup?: string
}

export const useLocationState = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const locationState = location.state as LocationStateType
  const persistentSelection = locationState?.persistentSelection
  const targetComponent = locationState?.targetComponent
  const targetField = locationState?.targetField
  const targetGroup = locationState?.targetGroup
  const selectedOptions =
    locationState?.sitemodelHistory?.at(-1)?.selectedOptions

  const [shouldResetData, setShouldResetData] = useState(
    !!locationState?.shouldResetData
  )
  const [shouldPersistData, setShouldPersistData] = useState(
    !!locationState?.shouldPersistData
  )

  const discardPersistentSelection = useCallback(() => {
    if (!persistentSelection) return

    const { persistentSelection: _, ...newState } = location.state
    navigate(location.pathname + location.search, {
      replace: true,
      state: newState
    })
  }, [
    location.pathname,
    location.search,
    location.state,
    navigate,
    persistentSelection
  ])

  const latestLocationState = useRef<LocationStateType>()

  if (locationState !== latestLocationState.current) {
    if (locationState) {
      if (!!locationState.shouldResetData !== shouldResetData) {
        setShouldResetData(!!locationState.shouldResetData)
      }

      if (!!locationState.shouldPersistData !== shouldPersistData) {
        setShouldPersistData(!!locationState?.shouldPersistData)
      }
    }

    latestLocationState.current = locationState
  }

  return {
    locationState,
    persistentSelection,
    shouldResetData,
    shouldPersistData,
    setShouldResetData,
    setShouldPersistData,
    targetComponent,
    targetField,
    targetGroup,
    selectedOptions,
    discardPersistentSelection
  }
}
